import { createComponent, MicrofrontendContext } from '@cian/mf-react';
import * as React from 'react';
import { IMicrofrontend } from '@cian/mf-registry/shared/microfrontend/types';
import { useApplicationContext } from '../../../ApplicationContext';

const PayPackageMicrofrontend = createComponent({
  mcs: 'pay-package-frontend',
  path: '/v1/get-pay-package-microfrontend/',
});

export const PayPackage = () => {
  const { microfrontend } = useApplicationContext();

  return (
    <div>
      <MicrofrontendContext.Provider value={microfrontend as IMicrofrontend}>
        <PayPackageMicrofrontend />
      </MicrofrontendContext.Provider>
    </div>
  );
};
